import axios from 'axios'
import TokenService from './token-service'
import store from '../store'
import { AuthenticationError } from './customer-service'
import Vue from '../main.js'
import CryptoAES from 'aes-ecb'
import { f7 } from 'framework7-vue';

class GenericError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const ApiService = {

    // Stores the 401 interceptor position so that it can be later ejected when needed
    _401interceptor: null,
    reconnectAxios: null,

    init() {
        // axios.defaults.baseURL = baseURL;
        this.reconnectAxios = axios.create()
        axios.defaults.timeout = process.env.VUE_APP_AXIOS_TIMEOUT
    },
	
    async setCustomHeader(accessLevel, token, otpCode){
        axios.defaults.headers.common["Content-Type"] = "application/json;charset=UTF-8"
        axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*"

        var tokenAccessLevel = [1, 2, 3, 4, 5, 6, 7, 9];
        var otpAccessLevel = [3, 4, 5, 6, 9];
        var clientIdAccessLevel = [5, 8, 9];
        var userAgentAccessLevel = [5, 8, 9];
        var deviceIdAccessLevel = [7];
        var uuidAccessLevel = [5, 9];
        var ipAddressAccessLevel = [8];

        if(tokenAccessLevel.includes(accessLevel)){
            axios.defaults.headers.common["Authorization"] = `Bearer ` + token
        }

        if(otpAccessLevel.includes(accessLevel)){
            axios.defaults.headers.common["WANDRE-OTP-Code"] = otpCode
        }

        if(clientIdAccessLevel.includes(accessLevel)){
            axios.defaults.headers.common["Client-Id"] = process.env.VUE_APP_CLIENT_ID
        }

        if(uuidAccessLevel.includes(accessLevel)){
            axios.defaults.headers.common["WANDRE-OTP-UUID"] = this.getFormData("uuid")
        }

        if(userAgentAccessLevel.includes(accessLevel)){
            axios.defaults.headers.common["User-Agent"] = navigator.userAgent;
        }

        if(deviceIdAccessLevel.includes(accessLevel)){
            axios.defaults.headers.common["WANDRE-DeviceId"] = "af206a1b9579311235714bfd445fba6c";
        }

        if(ipAddressAccessLevel.includes(accessLevel)){
            axios.defaults.headers.common["ipAddress"] = "";
        }

        //console.log("setCustomHeader, sessionId : "+this.getFormData("session-id"))
        //console.log("setCustomHeader, axsQueryPartnerCustomerId : "+this.getFormData("axsQueryPartnerCustomerId"))
        
        const isAxsrState = store.state.registration.isAxsr;
        if(isAxsrState){
            let partnerCustomerId = this.getFormData("axsQueryPartnerCustomerId");
            if(!partnerCustomerId){
                partnerCustomerId = ""
            }         
            const randVal = await this.getRandomValue();
            const secretKeyAXS  = "Ho3U6ui$5s"+randVal; //process.env.VUE_APP_AXSSK+randVal;
            //console.log("setCustomHeader, randVal : "+randVal+" ## secretKeyAXS : "+secretKeyAXS+" ## partnerCustomerId : "+partnerCustomerId)
            axios.defaults.headers.common["device-Id"] = encodeURIComponent(CryptoAES.encrypt(secretKeyAXS, partnerCustomerId));
        }else{
            axios.defaults.headers.common["device-Id"] = ""
        }
    },

    async setHeader() {
        axios.defaults.headers.common["Content-Type"] = "application/json;charset=UTF-8"
        axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*"
        axios.defaults.headers.common["Authorization"] = `Bearer ${TokenService.getToken()}`
        axios.defaults.headers.common["Client-Id"] = process.env.VUE_APP_CLIENT_ID

        //console.log("setheader, sessionId : "+this.getFormData("session-id"))
        //console.log("setheader, axsQueryPartnerCustomerId : "+this.getFormData("axsQueryPartnerCustomerId"))
        const isAxsrState = store.state.registration.isAxsr;
        if(isAxsrState){
            let partnerCustomerId = this.getFormData("axsQueryPartnerCustomerId");
            if(!partnerCustomerId){
                partnerCustomerId = ""
            }
            const randVal = await this.getRandomValue();            
            const secretKeyAXS  = "Ho3U6ui$5s"+randVal; //process.env.VUE_APP_AXSSK+randVal;
            //console.log("setHeader, randVal : "+randVal+" ## secretKeyAXS : "+secretKeyAXS+" ## partnerCustomerId : "+partnerCustomerId)
            axios.defaults.headers.common["device-Id"] = encodeURIComponent(CryptoAES.encrypt(secretKeyAXS, partnerCustomerId));
        }else{
            axios.defaults.headers.common["device-Id"] = ""
        }

        /*if(isAxsrState){
            axios.defaults.headers.common["device-Id"] = "50af2b870d0d5ad621c3862c78abe63356a8a5d19c409a1293df48a1bc0eef90"
        }else{
            axios.defaults.headers.common["device-Id"] = ""
        }*/
    },

    removeHeader() {
        axios.defaults.headers.common = {}
    },

    async generateAuthClient(randVal) {
        if (TokenService.getToken()) {
            // let sgTime = new Date().toLocaleString("en-US", {timeZone: 'Asia/Singapore'});
            // var today = new Date(sgTime);
            // var dd = String(today.getDate()).padStart(2, '0');
            // var MM = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            // var yy = today.getFullYear().toString().substr(-2);
            // var hh = String(today.getHours()).padStart(2, '0');
            // var todayNew = MM + dd + yy + hh;
            if(!randVal) {
                randVal = await this.getRandomValue();
            }
            var secretKey  = process.env.VUE_APP_AHSTK+randVal;
            axios.defaults.headers.common["Auth-Client"] = encodeURIComponent(CryptoAES.encrypt(secretKey, TokenService.getToken()));
            
            //console.log("generateAuthClient, sessionId : "+this.getFormData("session-id"))
            //console.log("generateAuthClient, axsQueryPartnerCustomerId : "+this.getFormData("axsQueryPartnerCustomerId"))
            const isAxsrState = store.state.registration.isAxsr;
            if(isAxsrState){
                let partnerCustomerId = this.getFormData("axsQueryPartnerCustomerId");
                if(!partnerCustomerId){
                    partnerCustomerId = ""
                }             
                const secretKeyAXS  = "Ho3U6ui$5s"+randVal; //process.env.VUE_APP_AXSSK+randVal;
                //console.log("generateAuthClient, randVal : "+randVal+" ## secretKeyAXS : "+secretKeyAXS+" ## partnerCustomerId : "+partnerCustomerId)
                axios.defaults.headers.common["device-Id"] = encodeURIComponent(CryptoAES.encrypt(secretKeyAXS, partnerCustomerId));
            }else{
                axios.defaults.headers.common["device-Id"] = ""
            }
        }
    },

    async get(resource, param) {
        if (process.env.VUE_APP_MODE != 'DEVELOPMENT') {
            resource = resource.replace('oauth/', process.env.VUE_APP_P2H_OAUTH_API_URL)
            resource = resource.replace('main/', process.env.VUE_APP_P2H_MAIN_API_URL)
            
        }

        const isAxsrState = store.state.registration.isAxsr;
        let deviceId = "";
        if(isAxsrState){
            let partnerCustomerId = this.getFormData("axsQueryPartnerCustomerId");
            if(!partnerCustomerId){
                partnerCustomerId = ""
            }         
            const randVal = await this.getRandomValue();
            const secretKeyAXS  = "Ho3U6ui$5s"+randVal; //process.env.VUE_APP_AXSSK+randVal;
            //console.log("axios get, partnerCustomerId : "+partnerCustomerId)
            deviceId = encodeURIComponent(CryptoAES.encrypt(secretKeyAXS, partnerCustomerId));
        }

        const getHeaders = {
            'device-Id': deviceId
        }

        let config = {
            headers: getHeaders,
            params: param.params
          }

        return axios.get(resource, config)
        .catch(err => {
            Vue.hidePreloader()
            // console.log(err);
            // console.log(err.code);
            // console.log(err.response);
            if (!err.response || err.code === 'ECONNABORTED' || err.response.status == 500 || err.response.status == 404) {
                this.setMaintenance(true, true);
            // } else if(err.response.status == 404) {
            //     Vue.$f7.dialog.alert(Vue.$t('general-ws-error-description'), Vue.$t('general-ws-error-title'));
            } else if(err.response.data.status == 90017 || err.response.data.error == 90017) {
                TokenService.removeTokenExpiry();
                Vue.checkTokenExpiry()
            } else if(err.response.data.status == 90006 || err.response.data.error == 90006 || err.response.data.status == 90005 || err.response.data.error == 90005) {
                this.moveToLoginPage()
            } else {
                Vue.checkTokenExpiry()
            }
        })
    },

    async post(resource, data) {
        if (process.env.VUE_APP_MODE != 'DEVELOPMENT') {
            resource = resource.replace('oauth/', process.env.VUE_APP_P2H_OAUTH_API_URL)
            resource = resource.replace('main/', process.env.VUE_APP_P2H_MAIN_API_URL)
        }

        const isAxsrState = store.state.registration.isAxsr;
        let deviceId = "";
        if(isAxsrState){
            let partnerCustomerId = this.getFormData("axsQueryPartnerCustomerId");
            if(!partnerCustomerId){
                partnerCustomerId = ""
            }         
            const randVal = await this.getRandomValue();
            const secretKeyAXS  = "Ho3U6ui$5s"+randVal; //process.env.VUE_APP_AXSSK+randVal;
            //console.log("axios post, partnerCustomerId : "+partnerCustomerId)
            deviceId = encodeURIComponent(CryptoAES.encrypt(secretKeyAXS, partnerCustomerId));
        }

        const postHeaders = {
            'device-Id': deviceId
        }

        return axios.post(resource, data, {headers: postHeaders})
        .catch(err => {
            Vue.hidePreloader()
            // console.log(err);
            // console.log(err.code);
            // console.log(err.response);
            if (!err.response || err.code === 'ECONNABORTED' || err.response.status == 500 || err.response.status == 404) {
                this.setMaintenance(true, true);
            // } else if(err.response.status == 404) {
            //     Vue.$f7.dialog.alert(Vue.$t('general-ws-error-description'), Vue.$t('general-ws-error-title'));
            } else if(err.response.data.status == 90017 || err.response.data.error == 90017) {
                TokenService.removeTokenExpiry();
                Vue.checkTokenExpiry()
            } else if(err.response.data.status == 90006 || err.response.data.error == 90006 || err.response.data.status == 90005 || err.response.data.error == 90005) {
                this.moveToLoginPage()
            } else {
                Vue.checkTokenExpiry()
            }
        })
    },

    async put(resource, data) {
        if (process.env.VUE_APP_MODE != 'DEVELOPMENT') {
            resource = resource.replace('oauth/', process.env.VUE_APP_P2H_OAUTH_API_URL)
            resource = resource.replace('main/', process.env.VUE_APP_P2H_MAIN_API_URL)
        }

        const isAxsrState = store.state.registration.isAxsr;
        let deviceId = "";
        if(isAxsrState){
            let partnerCustomerId = this.getFormData("axsQueryPartnerCustomerId");
            if(!partnerCustomerId){
                partnerCustomerId = ""
            }         
            const randVal = await this.getRandomValue();
            const secretKeyAXS  = "Ho3U6ui$5s"+randVal; //process.env.VUE_APP_AXSSK+randVal;
            //console.log("axios put, partnerCustomerId : "+partnerCustomerId)
            deviceId = encodeURIComponent(CryptoAES.encrypt(secretKeyAXS, partnerCustomerId));
        }

        const putHeaders = {
            'device-Id': deviceId
        }

        return axios.put(resource, data, {headers: putHeaders})
        .catch(err => {
            Vue.hidePreloader()
            // console.log(err);
            // console.log(err.code);
            // console.log(err.response);
            if (!err.response || err.code === 'ECONNABORTED' || err.response.status == 500 || err.response.status == 404) {
                this.setMaintenance(true. true);
            // } else if(err.response.status == 404) {
            //     Vue.$f7.dialog.alert(Vue.$t('general-ws-error-description'), Vue.$t('general-ws-error-title'));
            } else if(err.response.data.status == 90017 || err.response.data.error == 90017) {
                TokenService.removeTokenExpiry();
                Vue.checkTokenExpiry()
            } else if(err.response.data.status == 90006 || err.response.data.error == 90006 || err.response.data.status == 90005 || err.response.data.error == 90005) {
                this.moveToLoginPage()
            } else {
                Vue.checkTokenExpiry()
            }
        })
    },

    delete(resource) {
        if (process.env.VUE_APP_MODE != 'DEVELOPMENT') {
            resource = resource.replace('oauth/', process.env.VUE_APP_P2H_OAUTH_API_URL)
            resource = resource.replace('main/', process.env.VUE_APP_P2H_MAIN_API_URL)
        }

        return axios.delete(resource)
        .catch(err => {
            Vue.hidePreloader()
            // console.log(err);
            // console.log(err.code);
            // console.log(err.response);
            if (!err.response || err.code === 'ECONNABORTED' || err.response.status == 500 || err.response.status == 404) {
                this.setMaintenance(true, true);
            // } else if(err.response.status == 404) {
            //     Vue.$f7.dialog.alert(Vue.$t('general-ws-error-description'), Vue.$t('general-ws-error-title'));
            } else if(err.response.data.status == 90017 || err.response.data.error == 90017) {
                TokenService.removeTokenExpiry();
                Vue.checkTokenExpiry()
            } else if(err.response.data.status == 90006 || err.response.data.error == 90006 || err.response.data.status == 90005 || err.response.data.error == 90005) {
                this.moveToLoginPage()
            } else {
                Vue.checkTokenExpiry()
            }
        })
    },

    validateResponse(response, successRespCode) {
        if (response.data.status == successRespCode) {
            return response.data.result;
        } else if (response.data.status == '90008') { // Access Token expired
            throw new AuthenticationError(response.data.status, response.data.message)
        } else if (response.data.status == '0102') { // wrong PIN
            return response.data.status;
        } else if (response.data.status == '1608') { // coupon code invalid
            return response.data.status;
        }else {
            throw new GenericError(response.data.status, response.data.message)
        }
    },

    /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
    **/
    customRequest(data) {
        let checkMaintenance = !data.url.includes('pushnotification/')
        if (process.env.VUE_APP_MODE != 'DEVELOPMENT') {
            data.url = data.url.replace('/oauth/', process.env.VUE_APP_P2H_OAUTH_API_URL)
            data.url = data.url.replace('main/', process.env.VUE_APP_P2H_MAIN_API_URL)
            data.url = data.url.replace('pushnotification/', process.env.VUE_APP_PUSH_NOTIFICATION_API_URL)
        }

        return axios(data)        
        .catch(err => {
            Vue.hidePreloader()
            // console.log(err);
            // console.log(err.code);
            // console.log(err.response);
            if (!err.response || err.code === 'ECONNABORTED' || err.response.status == 500 || err.response.status == 404) {
                if (checkMaintenance) {
                    this.setMaintenance(true, true);
                }
            // } else if(err.response.status == 404) {
            //     Vue.$f7.dialog.alert(Vue.$t('general-ws-error-description'), Vue.$t('general-ws-error-title'));
            } else if(err.response.data.status == 90017 || err.response.data.error == 90017) {
                TokenService.removeTokenExpiry();
                Vue.checkTokenExpiry()
            } else if(err.response.data.status == 90006 || err.response.data.error == 90006 || err.response.data.status == 90005 || err.response.data.error == 90005) {
                this.moveToLoginPage()
            } else {
                Vue.checkTokenExpiry()
            }
        })
    },

    customHeader(resource, data, header) {
        if (process.env.VUE_APP_MODE != 'DEVELOPMENT') {
            resource = resource.replace('/oauth/', process.env.VUE_APP_P2H_OAUTH_API_URL)
            resource = resource.replace('main/', process.env.VUE_APP_P2H_MAIN_API_URL)
        }

        return axios.post(resource, data, header)
        .catch(err => {
            Vue.hidePreloader()
            // console.log(err);
            // console.log(err.code);
            // console.log(err.response);
            if (!err.response || err.code === 'ECONNABORTED' || err.response.status == 500 || err.response.status == 404) {
                this.setMaintenance(true, true);
            // } else if(err.response.status == 404) {
            //     Vue.$f7.dialog.alert(Vue.$t('general-ws-error-description'), Vue.$t('general-ws-error-title'));
            } else if(err.response.data.status == 90017 || err.response.data.error == 90017) {
                TokenService.removeTokenExpiry();
                Vue.checkTokenExpiry()
            } else if(err.response.data.status == 90006 || err.response.data.error == 90006 || err.response.data.status == 90005 || err.response.data.error == 90005) {
                this.moveToLoginPage()
            } else {
                Vue.checkTokenExpiry()
            }
        })
    },

    reconnectToRequest(data) {
        let checkMaintenance = !data.url.includes('pushnotification/') && !data.url.includes('marketingurl/') ? true : false
        if (process.env.VUE_APP_MODE != 'DEVELOPMENT') {
            data.url = data.url.replace('/oauth/', process.env.VUE_APP_P2H_OAUTH_API_URL)
            data.url = data.url.replace('main/', process.env.VUE_APP_P2H_MAIN_API_URL)
            data.url = data.url.replace('pushnotification/', process.env.VUE_APP_PUSH_NOTIFICATION_API_URL)
            data.url = data.url.replace('marketingurl/', process.env.VUE_APP_MARKETING)
        }
        return this.reconnectAxios(data)        
        .catch(err => {
            Vue.hidePreloader()
            // console.log(err);
            // console.log(err.code);
            // console.log(err.response);
            if (!err.response || err.code === 'ECONNABORTED' || err.response.status == 500 || err.response.status == 404) {
                if (checkMaintenance) {
                    this.setMaintenance(true, true);
                }
            // } else if(err.response.status == 404) {
            //     Vue.$f7.dialog.alert(Vue.$t('general-ws-error-description'), Vue.$t('general-ws-error-title'));
            } else {
                Vue.checkTokenExpiry()
            }
        })
    },

    async getRandomValue() {
        var url = 'main/randomvalue';
        if (process.env.VUE_APP_MODE != 'DEVELOPMENT') {
            url = url.replace('main/', process.env.VUE_APP_P2H_MAIN_API_URL)   
        }
        const result = await axios.get(url, {})
        .catch(err => {
            Vue.hidePreloader()
            // console.log(err);
            // console.log(err.code);
            // console.log(err.response);
            if (!err.response || err.code === 'ECONNABORTED' || err.response.status == 500 || err.response.status == 404) {
                this.setMaintenance(true, true);
            }
        })
        return result.data;
    },

    async ping() {
        var url = 'main/ping';
        if (process.env.VUE_APP_MODE != 'DEVELOPMENT') {
            url = url.replace('main/', process.env.VUE_APP_P2H_MAIN_API_URL)   
        }
        const result = await axios.get(url, {})
        .then(res => {
            if (res) {
                this.setMaintenance(false);
            }
        })
        .catch(err => {
            Vue.hidePreloader()
            // console.log(err);
            // console.log(err.code);
            // console.log(err.response);
            if (!err.response || err.code === 'ECONNABORTED' || err.response.status == 500 || err.response.status == 404) {
                this.setMaintenance(true, false);
                return;
            }
        })
        return result.data;
    },

    mount401Interceptor() {
        this._401interceptor = axios.interceptors.response.use(
            (response) => {
                return response
            },
            async (error) => {
                if (error.request.status == 401) {
                    if (error.config.url.includes('/o/token/')) {
                        // Refresh token has failed. Logout the user
                        store.dispatch('auth/logout')
                        throw error
                    } else {
                        // Refresh the access token
                        try{
                            await store.dispatch('auth/refreshToken')
                            // Retry the original request
                            return this.reconnectToRequest({
                                method: error.config.method,
                                url: error.config.url,
                                data: error.config.data,
                                headers: error.config.headers
                            })
                        } catch (e) {
                            // Refresh has failed - reject the original request
                            throw error
                        }
                    }
                }

                // If error was not 401 just reject as is
                throw error
            }
        )
    },

    unmount401Interceptor() {
        // Eject the interceptor
        axios.interceptors.response.eject(this._401interceptor)
    },
    
    saveFormData(key, itemValue) {
        localStorage.removeItem(key)
        sessionStorage.removeItem(key)
        if ( f7.device.desktop ) {
            sessionStorage.setItem(key, itemValue)
        } else {
            localStorage.setItem(key, itemValue)
        }
        
    },
    
    removeFormData(key) {
        localStorage.removeItem(key)
        sessionStorage.removeItem(key)
    },

    getFormData(key) {
        // console.log("isDesktop APIMAIN", store.state)
        return sessionStorage.getItem(key) || localStorage.getItem(key)
    },

    // DR-1931: normalize a dotted native version ("3.4.1", "1.22", "1.22.1") into a single comparable integer:
    // major*1_000_000 + minor*1_000 + patch, each segment clamped to 0-999 and missing segments treated as 0.
    // So "1.22" -> 1_022_000 and "1.22.1" -> 1_022_001 (correctly ordered), and a multi-digit minor like 22 is
    // preserved. The WS compares this against the same-encoded APP_LINKS_MIN_VERSION_WANDRE_* cutoffs.
    // iOS sends marketing version + build number, e.g. "1.07 (0001)" — only the leading dotted version
    // counts, so everything from the first space/paren is stripped (AOS sends a bare versionName like "1.21").
    normalizeAppVersion(raw) {
        if (!raw) return 0
        const ver = String(raw).trim().split(/[\s(]/)[0]
        const parts = ver.split('.')
        const seg = (i) => {
            let n = parseInt(parts[i], 10)
            if (isNaN(n) || n < 0) n = 0
            if (n > 999) n = 999
            return n
        }
        return seg(0) * 1000000 + seg(1) * 1000 + seg(2)
    },

    // DR-1931: query-string fragment identifying the client OS + native build, appended to the MyInfo/SingPass
    // authorise calls so the WS can route App-Links-capable builds to the v5 account. Web browsers send osName=web.
    // appVersion is the normalized integer (see normalizeAppVersion); a non-numeric/absent version yields 0 (no v5).
    getMyinfoSignalQuery() {
        const osName = window.Android ? 'android' : (window.webkit ? 'ios' : 'web')
        const appVersion = this.normalizeAppVersion(this.getFormData("appVersion"))
        return '&osName=' + osName + '&appVersion=' + appVersion
    },
    removeAllFormData(){
        localStorage.removeItem("otp")
        localStorage.removeItem("tempCode")
        localStorage.removeItem("prefix")
        localStorage.removeItem("uuid")
        localStorage.removeItem("mobileNo")

        sessionStorage.removeItem("otp")
        sessionStorage.removeItem("tempCode")
        sessionStorage.removeItem("prefix")
        sessionStorage.removeItem("uuid")
        sessionStorage.removeItem("mobileNo")
    },

    moveToLoginPage() {
        store.dispatch('auth/logout')
        Vue.$f7.sheet.close();

        const isAxsrState = store.state.registration.isAxsr;
        let redirectToUrl = '/login';
        if(isAxsrState){
            redirectToUrl = '/axsr-login';
        }

        Vue.$f7.views.main.router.navigate(redirectToUrl, { ignoreCache : true, clearPreviousHistory  : true })
    },

    setMaintenance(mode, redirect) {
        // console.log("setMaintenance,"+mode+","+redirect)
        if (mode) {
            if (redirect) {
                // Navigate to maintenance page
                Vue.$f7.sheet.close();
                // store.dispatch('auth/logout')
                Vue.$f7.views.main.router.navigate("/maintenance", {
                    props: {
                        errorCode: process.env.VUE_APP_AXIOS_TIMEOUT_ERROR_CODE
                    }
                })
            }

            // Set maintenance mode on
            store.commit('auth/setMaintenance', true);
        } else {
            // Set maintenance mode off
            store.commit('auth/setMaintenance', false);
        }
    }
}

export default ApiService

export { ApiService, GenericError }